export default __webpack_public_path__ + "static/media/John_James_Audubon_Louisina_Heron_40_x_60_cm.0a83b59c.jpg";